import React from 'react';
import classnames from 'classnames2';
import styles from './Description.scss';
export var Description = function Description(props) {
  var fontClass = props.variant === 'condensed' ? styles.condensed : '';
  return React.createElement("p", {
    id: props.id,
    className: classnames(styles.description, fontClass, props.className),
    "data-test": props.dataTest
  }, props.children);
};